<template>
  <div>
    <div class="nav">
      <img class="bg" src="../assets/images/home/headerbg.png"/>
      <div class="main_box">
        <div class="logo" @click="toPath('/')">
          <img :src="logo" />
        </div>
        <el-menu :default-active="getPageIndex || '1'" class="el-menu" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">{{$t('header.Home')}}</el-menu-item>
          <el-menu-item index="2">{{$t('header.MyOrder')}}</el-menu-item>
        </el-menu>
        <div class="weChat-login" v-if="!LoginBtnShow" @click="handleLogin">
          <div class="weChat-box">
            <img src="../assets/images/icon5.png" alt />
            <span>{{$t('header.Login')}}</span>
          </div>
        </div>
         <div class="home_btn" v-if="LoginBtnShow">
          <div style="position: relative;padding-left: 58px;">
          <img class="player_icon" src="../assets/images/home/15.png" />
            <div class="name-box">
                <span class="hidden-mobile">{{mobile}} <i class="el-icon-arrow-down"></i></span>
                <div class="hidden-btn">
                  <span @click="toRegist(3)"><img src="../assets/images/home/edit.png"/>{{$t('header.changeYourPassword')}}</span>
                  <span @click="handleLogOut"><img src="../assets/images/home/out.png"/>{{$t('header.logout')}}</span>
                </div>
            </div>
          </div>
        </div>
        <div class="home_btn">
          <div class="name-box">
            <span class="hidden-mobile">{{select}} <i class="el-icon-arrow-down"></i></span>
            <div class="hidden-btn language">
              <span v-for="(item, index) in languageList" :key="index" @click="selectLanguage(item)" :class="[item.disable?'disable':'', item.value === select?'select':'noselect']">
                {{item.value}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/constant/config'
import { getDictList } from '@/api/buyTicket'
export default {
  data () {
    return {
      pageIndex: '1',
      thirdInfo: {
        headImgUrl: '',
        nickName: '',
        mobile: null
      },
      select: '简体中文',
      language: {
        select: '简体中文',
        obj: [
          {
            text: '简体中文',
            select: true,
            disable: false
          }
        ]
      }
    }
  },
  props: ['homeBtnHide', 'LoginBtnShow', 'banner', 'welcome', 'logo', 'languageList'],
  created () {
    this.thirdInfo = sessionStorage.getItem('thirdInfo') ? JSON.parse(sessionStorage.getItem('thirdInfo')) : {}
    if (this.LoginBtnShow) {
      this.mobile = sessionStorage.getItem('mobile')
    }
  },
  computed: {
    'getPageIndex': function () {
      // this.pageIndex = this.$route.path === '/myOrder'? '1':'2'
      console.log(this.$route.path, 'this.$route.path')
      console.log(this.pageIndex, 'this.pageIndex')
      return this.$route.path === '/myOrder' ? '2' : '1'
    }
  },
  watch: {
    'LoginBtnShow': function () {
      if (this.LoginBtnShow) {
        this.mobile = sessionStorage.getItem('mobile')
      }
    },
    'languageList': function () {
      this.getLanguages()
    }
  },
  methods: {
    getLanguages () {
      if (this.languageList && this.languageList.length > 0) {
        let index = this.languageList.findIndex(item => item.code === localStorage.getItem('languageCode'))
        if (index !== -1) {
          this.select = this.languageList[index].value
        } else {
          localStorage.setItem('languageCode', 'Simplified_Chinese')
        }
      }
    },
    toMyOrder () {
      if (this.LoginBtnShow) {
        this.$router.push('/myOrder')
      } else {
        this.$emit('handleLogin', '/myOrder')
      }
    },
    selectLanguage (item) {
      this.select = item.value
      localStorage.setItem('languageCode', item.code)
      if (this.$route.path !== '/') {
        this.$router.push({
          path: '/'
        })
      } else {
        location.reload()
      }
      // i18n 切换语言
      localStorage.setItem('languageCode', item.code)
      this.$i18n.locale = localStorage.getItem('languageCode')
    },
    toPath (path) {
      this.$router.push(path)
    },
    toRegist (i) {
      this.$emit('registShowEvent', i)
    },
    handleLogin () {
      this.$emit('handleLogin')
    },
    handleLogOut () {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('loginState')
      this.LoginBtnShow = false
      this.$emit('loginOut')
    },
    handleSelect (index) {
      if (!this.LoginBtnShow && index !== '1') {
        this.$emit('handleLogin')
        return
      }
      if (index === '1') {
        this.$router.push('/')
      } else {
        this.$router.push('/myOrder')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.nav {
  background-color: #241008;
  position: fixed;
  width: 100%;
  height: 80px;
  line-height: 80px;
  z-index: 2;
  .bg {
    height: 80px;
    opacity: 0.2;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.nav .main_box {
  position: relative;
  z-index: 9;
  height: 80px;
  .el-menu {
    float: left;
    margin-left: 254px;
    background: none;
    border: none;
    height: 80px;
    li {
      color: #FFFFFF;
      opacity: 0.6;
      height: 80px;
      line-height: 80px;
      background: none;
    }
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    color: white;
    opacity: 1;
  }
}
.nav .logo {
  // width: 188px;
  height: 52px;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -26px;
}
.nav .logo img {
  width: 100%;
  height: 50px;
}
.nav .welcome {
  font-size: 14px;
  color: #fff;
  padding-left: 15px;
  position: absolute;
  left: 120px;
}

.nav .order_btn {
  float: right;
  width: 155px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background-color: #ffb000;
  text-align: center;
  cursor: pointer;
}

.nav .order_btn:hover {
  background-color: #faab00;
}

.nav .order_btn .ico {
  display: inline-block;
  vertical-align: top;
  width: 15px;
  height: 22px;
  margin-top: 14px;
  margin-right: 5px;
  background-image: url(../assets/images/mobile.png);
}

.nav .home_btn {
  z-index: 2000;
  // position: absolute;
  float: right;
  padding-left: 52px;

  box-sizing: border-box;
  text-align: center;
  .player_icon {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .name-box {
    position: relative;
    // left: 50px;
    display: inline-block;
    padding: 0 15px;
    height: 36px;
    line-height: 36px;
    // background: #241008;
    color: #FFFFFF;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    .hidden-mobile {
      display: inline-block;
    }
    &:hover {
      background: #241008;
      .hidden-btn {
        display: block;
      }
      i {
        transform: rotateX(180deg);
      }
    }
    span {
      display: inline-block;
      vertical-align: middle;
      font-size: 16px;
    }
    .icon1 {
      display: inline-block;
      width: 20px;
      height: 22px;
      vertical-align: middle;
      margin: 0 6px 0 16px;
    }
    .icon2 {
      display: inline-block;
      width: 9px;
      height: 5px;
      vertical-align: middle;
    }
  }
  .language {
    .disable {
      pointer-events: none;
    }
    .select {
      color: #FFFFFF;
    }
    .noselect {
      color: #FFFFFF;
      opacity: 0.5;
    }
  }
  .hidden-btn {
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    text-align: center;
    padding-top: 4px;
    display: none;
    span {
      position: relative;
      height: 36px;
      font-size: 16px;
      color: #FFF;
      background: #241008;
      border-bottom: 1px solid;
      line-height: 36px;
      z-index: 100;
      display: block;
      width: 100%;
      padding-left: 20px;
      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 20px;
      }
    }
  }
}

.nav .home_btn .ico {
  display: inline-block;
  vertical-align: top;
  margin-top: 6px;
  margin-right: 3px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/images/home.png);
}

.banner {
  position: relative;
  z-index: 1;
  width: 100%;
  min-width: 1200px;
  height: 483px;
  overflow: hidden;
}
.el-carousel.el-carousel--horizontal {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.weChat-login {
  position: absolute;
  top: 0;
  right: -100px;
  width: 79px;
  height: 65px;
  line-height: 65px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0px 0px 6px 6px;
  text-align: center;
  cursor: pointer;
}
.weChat-box {
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
}
.weChat-box img {
  display: inline-block;
  width: 27px;
  height: 22px;
}
.weChat-box span {
  display: inline-block;
  width: 100%;
  height: 18px;
  font-size: 14px;
  margin-top: 8px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 18px;
  color: #241008;
}
</style>
